var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUngroupFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_733_337)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.707078 0.292893C1.0976 -0.0976311 1.73077 -0.0976311 2.12129 0.292893L27.7071 25.8787C28.0976 26.2692 28.0976 26.9024 27.7071 27.2929C27.3166 27.6834 26.6834 27.6834 26.2929 27.2929L25 26H3C1.34315 26 0 24.6569 0 23V7V6V4C0 3.18891 0.482822 2.49058 1.17673 2.17676L0.707078 1.70711C0.316554 1.31658 0.316554 0.683417 0.707078 0.292893ZM6.99997 8L23 24H3C2.44772 24 2 23.5523 2 23V8H6.99997ZM2.99997 4L4.99997 6H2V4H2.99997ZM9.75257 2.34151C9.38889 1.92587 8.75713 1.88376 8.34149 2.24744C7.92586 2.61112 7.88374 3.24288 8.24742 3.65852L11.4486 7.31702C11.8284 7.75105 12.377 8.00002 12.9538 8.00002H25C25.5523 8.00002 26 8.44773 26 9.00002V21.5C26 22.0523 26.4477 22.5 27 22.5C27.5523 22.5 28 22.0523 28 21.5V9.00002C28 7.34316 26.6569 6.00001 25 6.00001H12.9538L9.75257 2.34151Z",
    fill: "#3D3D3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_733_337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUngroupFolder);
export default __webpack_public_path__ + "static/media/ungroup_folder.0381fad8e3842a65a2c5f72ff3da5967.svg";
export { ForwardRef as ReactComponent };